var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/forbid-prop-types */

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");

var ButtonGroup = require("react-components/button-group.jsx");
var InfoTip = require("../components/info-tip.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var RangeInput = require("../components/range-input.jsx");
var TeX = require("react-components/tex.jsx");
var Util = require("../util.js");
var KhanMath = require("../util/math.js");

var _require = require("../styles/constants.js"),
    interactiveSizes = _require.interactiveSizes;

var defaultBackgroundImage = {
    url: null,
    width: 0,
    height: 0
};

function numSteps(range, step) {
    return Math.floor((range[1] - range[0]) / step);
}

var GraphSettings = React.createClass({
    displayName: "GraphSettings",

    propTypes: _extends({}, Changeable.propTypes, {
        editableSettings: React.PropTypes.arrayOf(React.PropTypes.oneOf(["canvas", "graph", "snap", "image", "measure"])),
        box: React.PropTypes.arrayOf(React.PropTypes.number),
        labels: React.PropTypes.arrayOf(React.PropTypes.string),
        range: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.number)),
        step: React.PropTypes.arrayOf(React.PropTypes.number),
        gridStep: React.PropTypes.arrayOf(React.PropTypes.number),
        snapStep: React.PropTypes.arrayOf(React.PropTypes.number),
        valid: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
        backgroundImage: React.PropTypes.object,
        markings: React.PropTypes.oneOf(["graph", "grid", "none"]),
        showProtractor: React.PropTypes.bool,
        showRuler: React.PropTypes.bool,
        showTooltips: React.PropTypes.bool,
        rulerLabel: React.PropTypes.string,
        rulerTicks: React.PropTypes.number
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            editableSettings: ["graph", "snap", "image", "measure"],
            box: [interactiveSizes.defaultBoxSizeSmall, interactiveSizes.defaultBoxSizeSmall],
            labels: ["x", "y"],
            range: [[-10, 10], [-10, 10]],
            step: [1, 1],
            gridStep: [1, 1],
            snapStep: [1, 1],
            valid: true,
            backgroundImage: defaultBackgroundImage,
            markings: "graph",
            showProtractor: false,
            showRuler: false,
            showTooltips: false,
            rulerLabel: "",
            rulerTicks: 10
        };
    },

    getInitialState: function getInitialState() {
        return this.stateFromProps(this.props);
    },

    componentDidMount: function componentDidMount() {
        this.changeGraph = _.debounce(this.changeGraph, 300);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        // Make sure that state updates when switching
        // between different items in a multi-item editor.
        if (!_.isEqual(this.props.labels, nextProps.labels) || !_.isEqual(this.props.gridStep, nextProps.gridStep) || !_.isEqual(this.props.snapStep, nextProps.snapStep) || !_.isEqual(this.props.step, nextProps.step) || !_.isEqual(this.props.range, nextProps.range) || !_.isEqual(this.props.backgroundImage, nextProps.backgroundImage)) {
            this.setState(this.stateFromProps(nextProps));
        }
    },

    stateFromProps: function stateFromProps(props) {
        return {
            labelsTextbox: props.labels,
            gridStepTextbox: props.gridStep,
            snapStepTextbox: props.snapStep,
            stepTextbox: props.step,
            rangeTextbox: props.range,
            backgroundImage: _.clone(props.backgroundImage)
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    // TODO(aria): Make either a wrapper for standard events to work
    // with this.change, or make these use some TextInput/NumberInput box
    changeRulerLabel: function changeRulerLabel(e) {
        this.change({ rulerLabel: e.target.value });
    },

    changeRulerTicks: function changeRulerTicks(e) {
        this.change({ rulerTicks: +e.target.value });
    },

    changeBackgroundUrl: function changeBackgroundUrl(e) {
        var _this = this;

        // Only continue on blur or "enter"
        if (e.type === "keypress" && e.key !== "Enter") {
            return;
        }

        var setUrl = function setUrl(url, width, height) {
            var image = _.clone(_this.props.backgroundImage);
            image.url = url;
            image.width = width;
            image.height = height;
            _this.setState({
                backgroundImage: image
            }, _this.changeGraph);
        };

        var url = ReactDOM.findDOMNode(this.refs["bg-url"]).value;
        if (url) {
            Util.getImageSize(url, function (width, height) {
                if (_this.isMounted()) {
                    setUrl(url, width, height);
                }
            });
        } else {
            setUrl(null, 0, 0);
        }
    },

    renderLabelChoices: function renderLabelChoices(choices) {
        return _.map(choices, function (nameAndValue) {
            return React.createElement(
                "option",
                { value: nameAndValue[1] },
                nameAndValue[0]
            );
        });
    },

    validRange: function validRange(range) {
        var numbers = _.every(range, function (num) {
            return _.isFinite(num);
        });
        if (!numbers) {
            return "Range must be a valid number";
        }
        if (range[0] >= range[1]) {
            return "Range must have a higher number on the right";
        }
        return true;
    },

    validateStepValue: function validateStepValue(settings) {
        var step = settings.step,
            range = settings.range,
            name = settings.name,
            minTicks = settings.minTicks,
            maxTicks = settings.maxTicks;


        if (!_.isFinite(step)) {
            return name + " must be a valid number";
        }
        var nSteps = numSteps(range, step);
        if (nSteps < minTicks) {
            return name + " is too large, there must be at least " + minTicks + " ticks.";
        }
        if (nSteps > maxTicks) {
            return name + " is too small, there can be at most " + maxTicks + " ticks.";
        }
        return true;
    },

    validSnapStep: function validSnapStep(step, range) {
        return this.validateStepValue({
            step: step,
            range: range,
            name: "Snap step",
            minTicks: 5,
            maxTicks: 60
        });
    },

    validGridStep: function validGridStep(step, range) {
        return this.validateStepValue({
            step: step,
            range: range,
            name: "Grid step",
            minTicks: 3,
            maxTicks: 60
        });
    },

    validStep: function validStep(step, range) {
        return this.validateStepValue({
            step: step,
            range: range,
            name: "Step",
            minTicks: 3,
            maxTicks: 20
        });
    },

    validBackgroundImageSize: function validBackgroundImageSize(image) {
        // Ignore empty images
        if (!image.url) {
            return true;
        }

        var validSize = image.width <= 450 && image.height <= 450;

        if (!validSize) {
            return "Image must be smaller than 450px x 450px.";
        }
        return true;
    },

    validateGraphSettings: function validateGraphSettings(range, step, gridStep, snapStep, image) {
        var self = this;
        var msg = void 0;
        var goodRange = _.every(range, function (range) {
            msg = self.validRange(range);
            return msg === true;
        });
        if (!goodRange) {
            return msg;
        }
        var goodStep = _.every(step, function (step, i) {
            msg = self.validStep(step, range[i]);
            return msg === true;
        });
        if (!goodStep) {
            return msg;
        }
        var goodGridStep = _.every(gridStep, function (gridStep, i) {
            msg = self.validGridStep(gridStep, range[i]);
            return msg === true;
        });
        if (!goodGridStep) {
            return msg;
        }
        var goodSnapStep = _.every(snapStep, function (snapStep, i) {
            msg = self.validSnapStep(snapStep, range[i]);
            return msg === true;
        });
        if (!goodSnapStep) {
            return msg;
        }
        var goodImageSize = this.validBackgroundImageSize(image);
        if (goodImageSize !== true) {
            msg = goodImageSize;
            return msg;
        }
        return true;
    },

    changeLabel: function changeLabel(i, e) {
        var val = e.target.value;
        var labels = this.state.labelsTextbox.slice();
        labels[i] = val;
        this.setState({ labelsTextbox: labels }, this.changeGraph);
    },

    changeRange: function changeRange(i, values) {
        var ranges = this.state.rangeTextbox.slice();
        ranges[i] = values;
        var step = this.state.stepTextbox.slice();
        var gridStep = this.state.gridStepTextbox.slice();
        var snapStep = this.state.snapStepTextbox.slice();
        var scale = Util.scaleFromExtent(ranges[i], this.props.box[i]);
        if (this.validRange(ranges[i]) === true) {
            step[i] = Util.tickStepFromExtent(ranges[i], this.props.box[i]);
            gridStep[i] = Util.gridStepFromTickStep(step[i], scale);
            snapStep[i] = gridStep[i] / 2;
        }
        this.setState({
            stepTextbox: step,
            gridStepTextbox: gridStep,
            snapStepTextbox: snapStep,
            rangeTextbox: ranges
        }, this.changeGraph);
    },

    changeStep: function changeStep(step) {
        this.setState({ stepTextbox: step }, this.changeGraph);
    },

    changeSnapStep: function changeSnapStep(snapStep) {
        this.setState({ snapStepTextbox: snapStep }, this.changeGraph);
    },

    changeGridStep: function changeGridStep(gridStep) {
        this.setState({
            gridStepTextbox: gridStep,
            snapStepTextbox: _.map(gridStep, function (step) {
                return step / 2;
            })
        }, this.changeGraph);
    },

    changeGraph: function changeGraph() {
        var labels = this.state.labelsTextbox;
        var range = _.map(this.state.rangeTextbox, function (range) {
            return _.map(range, Number);
        });
        var step = _.map(this.state.stepTextbox, Number);
        var gridStep = this.state.gridStepTextbox;
        var snapStep = this.state.snapStepTextbox;
        var image = this.state.backgroundImage;

        // validationResult is either:
        //   true -> the settings are valid
        //   a string -> the settings are invalid, and the explanation
        //               is contained in the string
        // TODO(aria): Refactor this to not be confusing
        var validationResult = this.validateGraphSettings(range, step, gridStep, snapStep, image);

        if (validationResult === true) {
            // either true or a string
            this.change({
                valid: true,
                labels: labels,
                range: range,
                step: step,
                gridStep: gridStep,
                snapStep: snapStep,
                backgroundImage: image
            });
        } else {
            this.change({
                valid: validationResult // a string message, not false
            });
        }
    },

    render: function render() {
        var _this2 = this;

        var scale = [KhanMath.roundTo(2, Util.scaleFromExtent(this.props.range[0], this.props.box[0])), KhanMath.roundTo(2, Util.scaleFromExtent(this.props.range[1], this.props.box[1]))];

        return React.createElement(
            "div",
            null,
            _.contains(this.props.editableSettings, "canvas") && React.createElement(
                "div",
                { className: "graph-settings" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    "Canvas size (x,y pixels)",
                    React.createElement(RangeInput, {
                        value: this.props.box,
                        onChange: function onChange(box) {
                            _this2.change({ box: box });
                        }
                    })
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    "Scale (px per div):",
                    " ",
                    React.createElement(
                        TeX,
                        null,
                        "(" + scale[0] + ", " + scale[1] + ")"
                    )
                )
            ),
            _.contains(this.props.editableSettings, "graph") && React.createElement(
                "div",
                { className: "graph-settings" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "div",
                        { className: "perseus-widget-left-col" },
                        " ",
                        "x Label",
                        React.createElement("input", {
                            type: "text",
                            className: "graph-settings-axis-label",
                            ref: "labels-0",
                            onChange: function onChange(e) {
                                return _this2.changeLabel(0, e);
                            },
                            value: this.state.labelsTextbox[0]
                        })
                    ),
                    React.createElement(
                        "div",
                        { className: "perseus-widget-right-col" },
                        "y Label",
                        React.createElement("input", {
                            type: "text",
                            className: "graph-settings-axis-label",
                            ref: "labels-1",
                            onChange: function onChange(e) {
                                return _this2.changeLabel(1, e);
                            },
                            value: this.state.labelsTextbox[1]
                        })
                    )
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "div",
                        { className: "perseus-widget-left-col" },
                        "x Range",
                        React.createElement(RangeInput, {
                            value: this.state.rangeTextbox[0],
                            onChange: function onChange(vals) {
                                return _this2.changeRange(0, vals);
                            }
                        })
                    ),
                    React.createElement(
                        "div",
                        { className: "perseus-widget-right-col" },
                        "y Range",
                        React.createElement(RangeInput, {
                            value: this.state.rangeTextbox[1],
                            onChange: function onChange(vals) {
                                return _this2.changeRange(1, vals);
                            }
                        })
                    )
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "div",
                        { className: "perseus-widget-left-col" },
                        "Tick Step",
                        React.createElement(RangeInput, {
                            value: this.state.stepTextbox,
                            onChange: this.changeStep
                        })
                    ),
                    React.createElement(
                        "div",
                        { className: "perseus-widget-right-col" },
                        "Grid Step",
                        React.createElement(RangeInput, {
                            value: this.state.gridStepTextbox,
                            onChange: this.changeGridStep
                        })
                    )
                ),
                _.contains(this.props.editableSettings, "snap") && React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "div",
                        { className: "perseus-widget-left-col" },
                        "Snap Step",
                        React.createElement(RangeInput, {
                            value: this.state.snapStepTextbox,
                            onChange: this.changeSnapStep
                        })
                    )
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "label",
                        null,
                        "Markings: "
                    ),
                    React.createElement(ButtonGroup, {
                        value: this.props.markings,
                        allowEmpty: false,
                        buttons: [{ value: "graph", content: "Graph" }, { value: "grid", content: "Grid" }, { value: "none", content: "None" }],
                        onChange: this.change("markings")
                    })
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    React.createElement(PropCheckBox, {
                        label: "Show tooltips",
                        showTooltips: this.props.showTooltips,
                        onChange: this.change
                    })
                )
            ),
            _.contains(this.props.editableSettings, "image") && React.createElement(
                "div",
                { className: "image-settings" },
                React.createElement(
                    "div",
                    null,
                    "Background image:"
                ),
                React.createElement(
                    "div",
                    null,
                    "Url:",
                    " ",
                    React.createElement("input", {
                        type: "text",
                        className: "graph-settings-background-url",
                        ref: "bg-url",
                        value: this.state.backgroundImage.url,
                        onChange: function onChange(e) {
                            var image = _.clone(_this2.props.backgroundImage);
                            image.url = e.target.value;
                            _this2.setState({ backgroundImage: image });
                        },
                        onKeyPress: this.changeBackgroundUrl,
                        onBlur: this.changeBackgroundUrl
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "Create an image in graphie, or use the \"Add image\" function to create a background."
                        )
                    )
                )
            ),
            _.contains(this.props.editableSettings, "measure") && React.createElement(
                "div",
                { className: "misc-settings" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "div",
                        { className: "perseus-widget-left-col" },
                        React.createElement(PropCheckBox, {
                            label: "Show ruler",
                            showRuler: this.props.showRuler,
                            onChange: this.change
                        })
                    ),
                    React.createElement(
                        "div",
                        { className: "perseus-widget-right-col" },
                        React.createElement(PropCheckBox, {
                            label: "Show protractor",
                            showProtractor: this.props.showProtractor,
                            onChange: this.change
                        })
                    )
                ),
                this.props.showRuler && React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "div",
                        null,
                        React.createElement(
                            "label",
                            null,
                            " ",
                            "Ruler label:",
                            " ",
                            React.createElement(
                                "select",
                                {
                                    onChange: this.changeRulerLabel,
                                    value: this.props.rulerLabel
                                },
                                React.createElement(
                                    "option",
                                    { value: "" },
                                    "None"
                                ),
                                React.createElement(
                                    "optgroup",
                                    { label: "Metric" },
                                    this.renderLabelChoices([["milimeters", "mm"], ["centimeters", "cm"], ["meters", "m"], ["kilometers", "km"]])
                                ),
                                React.createElement(
                                    "optgroup",
                                    { label: "Imperial" },
                                    this.renderLabelChoices([["inches", "in"], ["feet", "ft"], ["yards", "yd"], ["miles", "mi"]])
                                )
                            )
                        )
                    ),
                    React.createElement(
                        "div",
                        null,
                        React.createElement(
                            "label",
                            null,
                            " ",
                            "Ruler ticks:",
                            " ",
                            React.createElement(
                                "select",
                                {
                                    onChange: this.changeRulerTicks,
                                    value: this.props.rulerTicks
                                },
                                _.map([1, 2, 4, 8, 10, 16], function (n) {
                                    return React.createElement(
                                        "option",
                                        { value: n },
                                        n
                                    );
                                })
                            )
                        )
                    )
                )
            )
        );
    }
});

module.exports = GraphSettings;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/graph-settings.jsx
 ** module id = 240
 ** module chunks = 0 1
 **/